/* global angular, TweenMax, $ */
angular.module('ua5App.index')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when('', '/');
        $stateProvider.state('index', {
            url: '/',
            templateUrl: 'states/index/index.html',
            controller: 'IndexCtrl',
            controllerAs: 'ctrl',
            resolve: {
                // Posts Resolve Here //
                posts: ['PostsResource', function(PostsResource) {
                    return PostsResource.query().$promise;
                }]
            }
        });
    }])
    .animation('.state-index__content', ['$rootScope', function($rootScope) {
        var goingHome = false;
        $rootScope.$on('$stateChangeStart', function(e, toState) {
            if (toState.url === '/') {
                goingHome = true;
            } else {
                goingHome = false;
            }
        });
        // Animate in children
        return {
            enter: function(element, doneFn) {
                var children = $(element).children().children();
                TweenMax.staggerFromTo(children, 1.5, {
                    alpha: 0
                }, {
                    alpha: 1
                }, 0.5, doneFn);
            },
            leave: function(element, doneFn) {
                var children = $(element).children();
                if (goingHome) {
                    TweenMax.fromTo(children, 0.5, {
                        alpha: 1
                    }, {
                        alpha: 0,
                        onComplete: doneFn
                    });
                } else {
                    doneFn();
                }
            }
        };
    }])
    .run(['$rootScope', 'MetaFactory', function($rootScope, MetaFactory) {
        // Check to see if on landing page when route changes
        $rootScope.$on('$stateChangeSuccess', function(e, toState) {
            $rootScope.onLandingPage = toState.url === '/';
            // Set landing page meta. Need to place here since the landing
            // page is the parent of every child.
            MetaFactory.set({
                title: 'Storylines: Contemporary Art at the Guggenheim',
                description: 'Every work of art has a story. Explore 100+ contemporary works from the @Solomon R. Guggenheim Museum collection in Storylines',
                ogTitle: 'Storylines: Contemporary Art at the Guggenheim',
                ogDescription: 'Every work of art has a story. Explore 100+ contemporary works from the @Solomon R. Guggenheim Museum collection in Storylines'
            });
        });
    }])
    .controller('IndexCtrl', ['$rootScope', '$scope', '$state', 'posts', function($rootScope, $scope, $state, posts) {
        var self = this;
        self.posts = [];

        function isArtistInGroup(artist) {
            var i = self.posts.length;
            while (i--) {
                if (artist === self.posts[i].artist) {
                    return true;
                }
            }
            return false;
        }

        angular.forEach(posts, function(post) {
            var artist;
            var skip;
            var slug;
            var year;
            // Artists to skip
            skip = ['Trisha Donnelly'];
            slug = post.slug;
            artist = post.title;
            year = post.acf.birth_year; // jshint ignore:line
            angular.forEach(post.acf.artwork, function(artwork, index) {
                if (!isArtistInGroup(artist) && artwork.image && skip.indexOf(artist) === -1) {
                    self.posts.push({
                        artist: artist,
                        year: artwork.date,
                        image: artwork.image.sizes.medium,
                        imageLarge: artwork.image.sizes.large,
                        tags: artwork.tag.split(/\s*,\s*/),
                        imageIndex: index + 1,
                        slug: slug,
                        imageHeight: artwork.image.sizes['medium-height'],
                        imageWidth: artwork.image.sizes['medium-width'],
                        title: artwork.title
                    });
                }
            });
        });
    }])
;
